import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LetDirective } from '@ngrx/component';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ClipboardModule } from '@angular/cdk/clipboard';

import { SpThemesComponent } from '@sites/site-theme/src/components/themes.component';

import { SpDirectivesModule } from '@common/directives/directives.module';
import { SpColorPickerModule } from '@components/sp-color-picker/src/sp-color-picker.module';
import { SpFormControlsModule } from '@components/sp-form-controls';
import { SpSwitchComponent } from '@ui/sp-switch';

import { SpRadioGroupComponent } from '@ui/sp-radio-group';

import { SpAnimationSettingsComponent } from '@components/sp-animation-settings';
import { SpAdvancedBorderSettingsModule } from '@components/sp-advanced-border-settings';

import { SpAdvancedRadiusSettingsModule } from '@components/sp-advanced-radius-settings';

import { WebBackgroundImageSettingsModule } from '@web/shared/components/web-background-image-settings/web-background-image-settings.module';

import { ControlResolverComponent } from '@web/layout/content/page-content/resolvers/control-resolver.component';

import { ThemeSettingsComponent } from './theme-settings/theme-settings.component';
import { BlockSettingsComponent } from './block-settings/block-settings.component';
import { ZeroBlockSettingsComponent } from './zero-block-settings/zero-block-settings.component';
import { SpecificBlockSettingsComponent } from './specific-block-settings/specific-block-settings.component';
import { SpecificBlockMobileSettingsComponent } from './specific-block-settings/mobile-settings/mobile-settings.component';
import { SpecificSectionSettingsComponent } from './specific-section-settings/specific-section-settings.component';
import { ColumnSettingsComponent } from './column-settings/column-settings.component';
import { GridSettingsComponent } from '@web/shared/components/web-settings/grid-settings/grid-settings.component';
import { TabSettingsComponent } from './tab-settings/tab-settings.component';
import { TabAppearanceSettingsComponent } from './tab-settings/tab-appearance-settings/tab-appearance-settings.component';
import { TabItemSettingsComponent } from './tab-settings/tab-item-settings/tab-item-settings.component';
import { WidgetSettingsComponent } from './widget-settings/widget-settings.component';
import { WidgetBreadcrumbsComponent } from './widget-settings/widget-breadcrumbs/widget-breadcrumbs.component';

import { SettingsBodyComponent } from './settings-body/settings-body.component';
import { SettingsFooterComponent } from './settings-footer/settings-footer.component';
import { SettingsBreadcrumbsComponent } from './settings-breadcrumbs/settings-breadcrumbs.component';
import { BlockLibraryAddonComponent } from './block-settings/components/block-library-addon/block-library-addon.component';
import { PaidAccessNotificationComponent } from './paid-access-notification/paid-access-notification.component';
import { SpFormInputSettingsModule } from '@components/sp-form-input-settings';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SpButtonAdditionalEffectsSettingsComponent } from '@components/sp-button-additional-effects-settings';

import { WebCustomButtonComponent } from '@web/shared/components/web-custom-button/web-custom-button.component';
import { CdkDrag, CdkDragHandle, CdkDropList, CdkDropListGroup } from '@angular/cdk/drag-drop';
import { SpControlHandleComponent } from '@ui/sp-control-handle';
import { WebColorPickerComponent } from '@web/shared/components/web-color-picker/web-color-picker.component';
import { SpShopCartIconSettingsModule } from '@components/sp-shop-cart-icon-settings';

import { SpFileManagerComponentModule } from '@components/sp-file-manager';
import { BlockDisplayConditionSettingsComponent } from './block-settings/block-display-condition-settings/block-display-condition-settings.component';
import { ConditionItemSettingsComponent } from './block-settings/block-display-condition-settings/condition-item-settings/condition-item-settings.component';

import { WebDateTimePickerModule } from '@web/shared/components/web-date-time-picker/web-date-time-picker.module';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';

import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgSelectModule } from '@ng-select/ng-select';

const COMPONENTS = [
    ControlResolverComponent,
    ThemeSettingsComponent,
    BlockSettingsComponent,
    ZeroBlockSettingsComponent,
    SpecificBlockSettingsComponent,
    SpecificBlockMobileSettingsComponent,
    SpecificSectionSettingsComponent,
    ColumnSettingsComponent,
    GridSettingsComponent,
    TabSettingsComponent,
    TabAppearanceSettingsComponent,
    TabItemSettingsComponent,
    WidgetSettingsComponent,
    WidgetBreadcrumbsComponent,
    SettingsBodyComponent,
    SettingsFooterComponent,
    SettingsBreadcrumbsComponent,
    BlockLibraryAddonComponent,
    BlockDisplayConditionSettingsComponent,
    ConditionItemSettingsComponent,
];

const MODULES = [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LetDirective,
    TranslateModule,
    TooltipModule,
    SpThemesComponent,
    WebBackgroundImageSettingsModule,
    WebColorPickerComponent,
    SpDirectivesModule,
    SpColorPickerModule,
    SpFormControlsModule,
    SpSwitchComponent,
    SpRadioGroupComponent,
    ClipboardModule,
    SpAnimationSettingsComponent,
    SpAdvancedBorderSettingsModule,
    PaidAccessNotificationComponent,
    SpFileManagerComponentModule,
    SpShopCartIconSettingsModule,
    SpAdvancedRadiusSettingsModule,
    WebDateTimePickerModule,
    BsDatepickerModule,
    TimepickerModule,
];

@NgModule({
    imports: [
        ...MODULES,
        SpFormInputSettingsModule,
        BsDropdownModule,
        SpButtonAdditionalEffectsSettingsComponent,
        WebCustomButtonComponent,
        CdkDragHandle,
        SpControlHandleComponent,
        NgSelectModule,
        CdkDrag,
        CdkDropList,
        CdkDropListGroup,
        ...COMPONENTS,
    ],
    exports: [...COMPONENTS],
})
export class WebSettingsModule {}
